import React, { FC, useEffect, useMemo, useState, useRef } from "react";
import MovieDescription from "../../../../../../components/TicketBooking/MovieDescription";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../../store";
import "./foodAndBeverageReConfirmation.scss";
import { useLocation } from "react-router";
import { MODAL_TYPE, TICKET_FLOW_TYPES } from "../../../../../../models/tickets";
import { TICKET_FLOW } from "../../../../../../constants/ticket";
import { addTicketSuccess, setModal, toggleTicketModal } from "../../../../../../store/ticketBooking/action";
import { IMAGE_URL_CONFIG, URLS } from "../../../../../../constants/url";
import { onImgError } from "../../../../../../utils/helper";
import { formatSeatSwapPayload, formatSeatSwapResponse } from "../../../../../../utils/tickets";
import { swapSeatsApi } from "../../../../../../services/films";
import { toast } from "react-toastify";
interface INoOfSeatsProps {
    onCancel: (error?: string) => void;
}

const FoodAndBeverageReConfirmation: FC<INoOfSeatsProps> = ({ onCancel }) => {
    const {
        countryId,
        currentCinema,
        modalType,
        seatSwapDetails,
        ticketDetails,
        prevModal,
    } = useSelector((state: RootState) => ({
        countryId: state.applicationReducer.countryId,
        currentCinema: state.applicationReducer.currentCinema,
        modalType: state.ticketBookingReducer.modal.type,
        seatSwapDetails: state.ticketBookingReducer.seatSwapDetails,
        ticketDetails: state.ticketBookingReducer.ticketDetails,
        prevModal: state.ticketBookingReducer.modal?.prevModal
    }));

    const dispatch = useDispatch();
    const [errorMessage, setErrorMessage] = useState("");
    const [concessionDetails, setConcessionDetails] = useState([]);
console.log('concessionDetails', concessionDetails)
    useEffect(() => {
        if (seatSwapDetails && seatSwapDetails.concessionDetails) {
            setConcessionDetails(seatSwapDetails.concessionDetails)
        }
    }, [seatSwapDetails])

    const handleServiceChange = (item: any, value: any, i: number) => {

        if (!value) {
            item.isSelected = false;
        } else {
            const selectedSeat = ticketDetails?.selectedSeats?.find((seat: any) => seat.SeatId === value);
            if (selectedSeat) {
                item.deliveryInfo = {
                    ...item.deliveryInfo,
                    AreaNumber: selectedSeat.AreaNumber,
                    ColumnIndex: selectedSeat.ColumnIndex,
                    RowId: selectedSeat.RowIndex,
                    RowIndex: selectedSeat.RowIndex,
                    SeatNumber: selectedSeat.SeatId,
                }
                item.isSelected = true;

            }
        }

        const concessions: any = [...concessionDetails];
        concessions[i] = { ...item };
        setConcessionDetails(concessions);


    };

    const handleDeliveryChange = (item: any, value: any, i: number) => {
        item.deliveryInfo = {
            ...item.deliveryInfo,
            Comment: value
        }
        const concessions: any = [...concessionDetails];
        concessions[i] = { ...item };
        setConcessionDetails(concessions);
    };

    const onNext = async () => {
        setErrorMessage("");
        if (!concessionDetails.every((v: any) => v.isSelected)) {
            setErrorMessage('Service type is not selected');
            return;
        }

        const payload = formatSeatSwapPayload({
            seatSwapDetails,
            currentCinema,
            countryId,
            selectedSeat: ticketDetails.selectedSeats,
            concession: concessionDetails.map((v:any)=>{
                delete v.isSelected;
                return v;
            })
        });
        const { data } = await swapSeatsApi(payload);
        if (data && data.statusCode === 200 && data.data) {
            dispatch(
                addTicketSuccess(formatSeatSwapResponse({
                    seatSwapDetails,
                    selectedSeat: ticketDetails.selectedSeats,
                    data: data?.data
                })));
            const ticketType: TICKET_FLOW_TYPES = modalType;
            const next: MODAL_TYPE = MODAL_TYPE.TICKET_CONFIRMATION;
            const modalData = TICKET_FLOW[ticketType][next];
            dispatch(
                setModal({
                    ...modalData,
                    type: modalType,
                })
            );
        } else {
            dispatch(toggleTicketModal(false));
            toast.error(data?.data?.error?.errors ? data.data.error.errors.map((v:any)=>v.description).join(',') : "Error occured, please try later")
        }
    };

    const onPrev = async () => {
        const ticketType: TICKET_FLOW_TYPES = modalType;
        const prev: MODAL_TYPE = prevModal;
        const modal = TICKET_FLOW[ticketType][prev];
        dispatch(
            setModal({
                ...modal,
                type: modalType,
            })
        );
    };

    return (
        <div className="food-and-beverage-re-confirmation row">
            <MovieDescription />
            <div className="col-md-8 p-l-10 food-and-beverage">
                <div className="food-and-beverage">
                    <h5 className="title">
                        Please re-confirm the service for your food/beverage item(s) below.
                    </h5>

                    <div className="food-items">
                        {concessionDetails.map((item: any, index: number) => (
                            <div key={item.id} className="food-item">
                                <div className="food-top">
                                    <img src={seatSwapDetails.vistacdn + item?.Item_id} alt={item?.Description} onError={onImgError} />
                                    <div className="food-details">
                                        <h6>{item?.Description}</h6>
                                        <span>{item?.modifier?.join(" ,")}</span>
                                    </div>
                                </div>
                                {/* Food & Beverage Service Dropdown */}
                                <span>Food & Beverage Service</span>
                                <select
                                    className="full-width-select"
                                    onChange={(e) => handleServiceChange(item, e.target.value, index)}
                                >     <option value=''>Select service type</option>
                                    {ticketDetails?.selectedSeats?.map((seat: any) => (
                                        <option key={seat.SeatId} value={seat.SeatId}>
                                            Deliver to <b>Seat</b> {seat.SeatId}
                                        </option>
                                    ))}
                                </select>

                                {/* Show Deliver At dropdown only if seat delivery is selected */}
                                {item.isSelected === true && (
                                    <>
                                        <span>Deliver At</span>
                                        <select className="full-width-select-deliver-at" value={item?.deliveryInfo?.Comment}
                                            onChange={(e) => handleDeliveryChange(item, e.target.value, index)}>
                                            {['First Half', 'Second Half'].map((option: any) => (
                                                <option key={option} value={option}>
                                                    {option}
                                                </option>
                                            ))}
                                        </select>
                                    </>
                                )}
                            </div>
                        ))}
                    </div>
                    {errorMessage ? (
                        <div className="error_message">
                            <span>{errorMessage}</span>
                        </div>
                    ) : null}

                    
                </div>
            </div>
            <div className="actions-section">
                <button className="cancel-button" onClick={() => onCancel()}>CANCEL</button>
                <div className="actions">
                    <button
                        type="button"
                        className="btn gray_btn cancel"
                        onClick={onPrev}
                    >
                        <img src={IMAGE_URL_CONFIG.DEFAULT_IMAGE_PATH + 'arrow_white_left.svg'} alt="Arrow" />
                        <span>BACK</span>
                    </button>
                    <button className="btn gray_btn confirm" onClick={onNext}> <img className="white-tick" src={IMAGE_URL_CONFIG.DEFAULT_IMAGE_PATH + 'tick_white_small.svg'} alt="Tick" /> CONFIRM</button>
                </div>
            </div>
        </div>
    );
};

export default FoodAndBeverageReConfirmation;
